import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const containerStyle = {
  display: "flex"
};
const hoursStyle = {
  paddingTop: "30px",
  paddingLeft: "10px",
  fontWeight: "bold"
};
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { salesforceThrottleEnabled, accessTokenExpiresIn } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "salesforceThrottleEnabled",
      defaultChecked: salesforceThrottleEnabled == null ? void 0 : salesforceThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement("div", { style: containerStyle }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "accessTokenExpiresIn",
      name: "accessTokenExpiresIn",
      type: "number",
      value: accessTokenExpiresIn.value || accessTokenExpiresIn.defaultValue || "",
      min: "1",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in hours) the Salesforce API access token will expire. Default value is 1 hour.",
      label: "Salesforce Access Token Expires In"
    }
  ), /* @__PURE__ */ React.createElement("span", { style: hoursStyle }, "Hours")));
};
export default FormAdvancedOptions;
